// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__FGAFZ","inputWrap":"Table_inputWrap__3Mp3O","col":"Table_col__jYyUU","bmiTooltip":"Table_bmiTooltip__sGSsA"};